import {
  inject,
  Injectable,
  signal,
  Signal,
  WritableSignal,
} from '@angular/core';
import { doc, docData, Firestore } from '@angular/fire/firestore';
import {
  EventCounter,
  eventCounterConverter,
} from 'src/app/models/eventCounters.model';

@Injectable()
export class EventCounterStoreService {
  private firestore = inject(Firestore);
  private _eventCounter: WritableSignal<EventCounter | undefined> = signal<
    EventCounter | undefined
  >(undefined);
  eventCounter: Signal<EventCounter | undefined> =
    this._eventCounter.asReadonly();

  getById(id: string) {
    const eventCounterRef = doc(
      this.firestore,
      `eventCounters/${id}`,
    ).withConverter(eventCounterConverter);
    docData<EventCounter>(eventCounterRef, { idField: 'id' }).subscribe(
      (eventCounter) => {
        return this._eventCounter.set(eventCounter);
      },
    );
  }
}
